import React from 'react';
import LoaderCard from '../shared/LoaderCard';
import { useFetchAuditStructureQuery, useFetchUrlAuditQuery } from './service';
import AuditReport from './AuditReport';
import { Alert } from 'antd';

type Props = {
    websiteGuid: string;
    urlGuid: string;
};

export default function UrlAuditReport({ websiteGuid, urlGuid }: Props) {
    const { data: urlAudit, isLoading: isLoadingUrlAudit, isError: isAuditError } = useFetchUrlAuditQuery({ w_guid: websiteGuid, url_guid: urlGuid });
    const { data: auditStructure, isLoading: isLoadingAuditStructure, isError: isAuditStructureFetchingError } = useFetchAuditStructureQuery();

    const isLoading = isLoadingUrlAudit || isLoadingAuditStructure;
    const isReportNotFound = !isLoading && isAuditError;
    const isAuditStructureError = !isLoading && isAuditStructureFetchingError;
    const isSuccess = !isLoading && urlAudit && auditStructure;

    return (
        <>
            {isLoading && <LoaderCard description="Loading report..." />}
            {isReportNotFound && (
                <Alert
                    message="An error has occurred"
                    description="No report found"
                    type="error"
                    showIcon
                />
            )}
            {isAuditStructureError && (
                <Alert
                    message="An error has occurred"
                    description="Please try again"
                    type="error"
                    showIcon
                />
            )}
            {isSuccess && (
                <AuditReport
                    seoAudit={urlAudit}
                    seoAuditStructure={auditStructure}
                />
            )}
        </>
    );
}
